import { APP_START, STORE_SCHEMAS, SET_QUERY_READINESS, FETCH_PROJECT_DETAILS, FETCH_PROJECT_DETAILS_SUCCESS, FETCH_PROJECT_DETAILS_ERROR } from './constants';
export var appStart = function appStart() {
  return {
    type: APP_START
  };
};
export var storeSchemas = function storeSchemas() {
  return {
    type: STORE_SCHEMAS
  };
};
export var setQueryReadiness = function setQueryReadiness(isQueryReady) {
  return {
    type: SET_QUERY_READINESS,
    payload: {
      isQueryReady: isQueryReady
    }
  };
};
export var fetchProjectDetails = function fetchProjectDetails() {
  return {
    type: FETCH_PROJECT_DETAILS
  };
};
export var fetchProjectDetailsSuccess = function fetchProjectDetailsSuccess() {
  return {
    type: FETCH_PROJECT_DETAILS_SUCCESS
  };
};
export var fetchProjectDetailsError = function fetchProjectDetailsError(error) {
  return {
    type: FETCH_PROJECT_DETAILS_ERROR,
    payload: {
      error: error
    }
  };
};